function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", null, React.createElement("path", {
  fill: "none",
  stroke: "currentColor",
  strokeWidth: 5,
  strokeLinecap: "round",
  strokeMiterlimit: 10,
  d: "M10.077,50.889 c0,0,15.61,20.466,44.4,6.417"
}), React.createElement("line", {
  fill: "none",
  stroke: "currentColor",
  strokeWidth: 5,
  strokeLinecap: "round",
  strokeMiterlimit: 10,
  x1: 32.276,
  y1: 63.377,
  x2: 32.104,
  y2: 67.886
}), React.createElement("line", {
  fill: "none",
  stroke: "currentColor",
  strokeWidth: 5,
  strokeLinecap: "round",
  strokeMiterlimit: 10,
  x1: 51.008,
  y1: 59.907,
  x2: 52.916,
  y2: 64.071
}), React.createElement("line", {
  fill: "none",
  stroke: "currentColor",
  strokeWidth: 5,
  strokeLinecap: "round",
  strokeMiterlimit: 10,
  x1: 12.678,
  y1: 54.357,
  x2: 9.556,
  y2: 57.826
}), React.createElement("line", {
  fill: "none",
  stroke: "currentColor",
  strokeWidth: 5,
  strokeLinecap: "round",
  strokeMiterlimit: 10,
  x1: 21.523,
  y1: 59.734,
  x2: 19.442,
  y2: 64.591
}), React.createElement("line", {
  fill: "none",
  stroke: "currentColor",
  strokeWidth: 5,
  strokeLinecap: "round",
  strokeMiterlimit: 10,
  x1: 41.816,
  y1: 62.682,
  x2: 42.51,
  y2: 66.845
}));

var _ref3 =
/*#__PURE__*/
React.createElement("g", null, React.createElement("path", {
  fill: "none",
  stroke: "currentColor",
  strokeWidth: 5,
  strokeLinecap: "round",
  strokeMiterlimit: 10,
  d: "M118.055,50.961 c0,0-15.609,20.467-44.4,6.418"
}), React.createElement("line", {
  fill: "none",
  stroke: "currentColor",
  strokeWidth: 5,
  strokeLinecap: "round",
  strokeMiterlimit: 10,
  x1: 95.854,
  y1: 63.449,
  x2: 96.028,
  y2: 67.958
}), React.createElement("line", {
  fill: "none",
  stroke: "currentColor",
  strokeWidth: 5,
  strokeLinecap: "round",
  strokeMiterlimit: 10,
  x1: 77.124,
  y1: 59.98,
  x2: 75.216,
  y2: 64.144
}), React.createElement("line", {
  fill: "none",
  stroke: "currentColor",
  strokeWidth: 5,
  strokeLinecap: "round",
  strokeMiterlimit: 10,
  x1: 115.454,
  y1: 54.43,
  x2: 118.575,
  y2: 57.899
}), React.createElement("line", {
  fill: "none",
  stroke: "currentColor",
  strokeWidth: 5,
  strokeLinecap: "round",
  strokeMiterlimit: 10,
  x1: 106.607,
  y1: 59.807,
  x2: 108.688,
  y2: 64.664
}), React.createElement("line", {
  fill: "none",
  stroke: "currentColor",
  strokeWidth: 5,
  strokeLinecap: "round",
  strokeMiterlimit: 10,
  x1: 86.315,
  y1: 62.756,
  x2: 85.621,
  y2: 66.918
}));

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  fill: "currentColor",
  d: "M97.322,77.753c-11.458,1.376-21.592-0.387-25.979-4.058c-1.012,1.373-1.493,2.787-1.325,4.188 c0.732,6.102,13.385,9.599,28.258,7.812c14.874-1.785,26.338-8.177,25.605-14.277c-0.167-1.4-0.97-2.662-2.278-3.756 C118.21,72.266,108.782,76.377,97.322,77.753z"
});

var SvgDarkcircles = function SvgDarkcircles(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    id: "Capa_1",
    x: "0px",
    y: "0px",
    width: "128px",
    height: "128px",
    viewBox: "0 0 128 128",
    enableBackground: "new 0 0 128 128",
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgDarkcircles, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/darkcircles.f5f5e6f9.svg";
export { ForwardRef as ReactComponent };